export const call = {
  status: {
    answered: 'Answered',
    busy: 'Busy',
    no_answer: 'No answer',
    failed: 'Failed',
    active: 'Active',
    error: 'Error',
    processing: 'Processing'
  },

  type: {
    outgoing: 'Outgoing',
    incoming: 'Incoming'
  }
};
